import { useContext, useState } from 'react';
import classNames from 'classnames';

import { useTranslation } from '../../hooks';
import { MediaContext } from '../../context/MediaContext';
import CTA from '../Cta';
import AncillaryCard from './AncillaryCard';
import FeaturedAncillaryCard from './FeaturedAncillaryCard';
import './AncillaryCards.scss';

export default function AncillaryCards({ ancillaries = [] }) {
	const { t } = useTranslation();
	const media = useContext(MediaContext);

	const [isExpanded, setIsExpanded] = useState(media.isLessThan.md);

	const toggleExpanded = () => setIsExpanded(!isExpanded);

	return (
		<div className="ancillary-cards">
			{ancillaries.length === 1 && (
				<div className="ancillary-cards__featured-ancillary-card">
					<FeaturedAncillaryCard
						title={ancillaries[0].title}
						subTitle={ancillaries[0].subTitle}
						image={ancillaries[0].image}
						description={ancillaries[0].description}
						cta={ancillaries[0].cta}
					/>
				</div>
			)}

			{ancillaries.length > 1 && (
				<div
					className={classNames('ancillary-cards__row', {
						'ancillary-cards__row--two': ancillaries.length === 2,
						'ancillary-cards__row--expanded': isExpanded,
					})}
				>
					{ancillaries
						.slice(0, isExpanded ? Infinity : 3)
						.map(({ id, title, subTitle, image, description, cta }) => (
							<div className="ancillary-cards__col" key={id}>
								<AncillaryCard
									title={title}
									subTitle={subTitle}
									image={image}
									description={description}
									cta={cta}
									isWide={ancillaries.length === 2}
								/>
							</div>
						))}
				</div>
			)}

			{ancillaries.length > 3 && media.isGreaterThan.md && (
				<div className="ancillary-cards__actions">
					<CTA onClick={toggleExpanded} type="secondary">
						{isExpanded ? t('View Less') : t('View More')}
						<span className={isExpanded ? 'icon icon-less_sign' : 'icon icon-plus_sign'} />
					</CTA>
				</div>
			)}
		</div>
	);
}
